const checkFields = ['value', 'currentDate', 'doubleCurrentDate'] as const;

export default checkFields;
